var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 6 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E1E1E1",
  d: "M1.536 5.554 6 9.56 6 11 0 5.563 5.999 0v1.44z"
})));
export default SvgArrowLeft;